import React from 'react';

function MenuBarsIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      fill="none"
      viewBox="0 0 24 25"
      {...props}
    >
      <g>
        <path
          fill="#EF4136"
          d="M16 8.7H7.1C6.5 8.7 6 8.2 6 7.6c0-.6.5-1.1 1.1-1.1H16c.6 0 1.1.5 1.1 1.1 0 .6-.5 1.1-1.1 1.1zm1.1 4c0-.6-.5-1.1-1.1-1.1H7.1c-.6 0-1.1.4-1.1 1.1 0 .7.5 1.1 1.1 1.1H16c.6 0 1.1-.5 1.1-1.1zm0 5c0-.6-.5-1.1-1.1-1.1H7.1c-.6 0-1.1.5-1.1 1.1 0 .6.5 1.1 1.1 1.1H16c.6 0 1.1-.5 1.1-1.1z"
        ></path>
      </g>
    </svg>
  );
}

export default MenuBarsIcon;
